import * as React from 'react'

function SvgNotiInfoLine(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 2c5.522 0 10 4.477 10 10s-4.478 10-10 10S2 17.523 2 12 6.478 2 12 2zm0 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 5a1 1 0 011 1v7a1 1 0 11-2 0v-7a1 1 0 011-1zm0-3a1 1 0 110 2 1 1 0 010-2z" />
    </svg>
  )
}

export default SvgNotiInfoLine
